export default {
  methods: {
    vfg() {
      // short name for the flow generator component
      return this.$refs.flowGenerator
    },
    resetFlowGeneratorState() {
      this.vfg() && this.vfg().flowPreview().resetState()
    },
    isFlowValid() {
      return this.vfg()
        ? this.vfg().flowPreview().isFlowValid()
        : false
    },
    openAllPanels() {
      this.vfg() && this.vfg().flowPreview().openAllSteps()
    },
    validateSteps() {
      this.vfg() && this.vfg().flowPreview().validateAll()
    },
    cleanData() {
      this.vfg() && this.vfg().cleanData()
    },
    nextStep() {
      this.vfg() && this.vfg().flowPreview().debouncedActivateNextStep()
    },
    async openStep(stepName, scrollTo = true) {
      await this.$nextTick()
      this.vfg() && this.vfg().flowPreview().activateStep(stepName, scrollTo)
    },
  }
}
